/**
 * Prazo encerrado sem resgate no ciclo, na vitrine em consulta: no lugar do quadro "Sua escolha",
 * o aviso de que a premiação vem em pontos Livelo (VTR-12).
 */
export default function SemEscolhaNoPrazo({ semestre }: { semestre: string }) {
  return (
    <section aria-labelledby="titulo-sem-escolha" className="mb-8 rounded-xl bg-brand-white px-6 py-6 shadow-jj-01 sm:px-8">
      <h2 id="titulo-sem-escolha" className="m-0 mb-2 font-display text-[19px] font-bold leading-[normal] text-brand-blue-dark">
        Sua escolha
      </h2>
      <p className="m-0 text-[15px] leading-[1.6] text-content">
        O período de escolha {semestre ? `do ${semestre}` : 'deste ciclo'} se encerrou e você não registrou uma experiência. Você
        receberá sua premiação em pontos Livelo.
      </p>
    </section>
  );
}
